function requireEnv(
  rawValue: string | undefined,
  variableName: string,
): string {
  const value = rawValue?.trim();
  if (!value) {
    throw new Error(`${variableName} must be configured in the environment.`);
  }
  return value;
}

function parsePositiveInteger(
  rawValue: string | undefined,
  variableName: string,
): number {
  const value = requireEnv(rawValue, variableName);
  const parsedValue = Number(value);

  if (!Number.isInteger(parsedValue) || parsedValue <= 0) {
    throw new Error(`${variableName} must be a positive integer.`);
  }

  return parsedValue;
}

export const authServiceUrl = requireEnv(
  import.meta.env.VITE_AUTH_SERVICE_URL,
  "VITE_AUTH_SERVICE_URL",
);
export const authClientId = requireEnv(
  import.meta.env.VITE_AUTH_CLIENT_ID,
  "VITE_AUTH_CLIENT_ID",
);
export const authRefreshBufferSeconds = parsePositiveInteger(
  import.meta.env.VITE_AUTH_REFRESH_BUFFER_SECONDS,
  "VITE_AUTH_REFRESH_BUFFER_SECONDS",
);
const rawSiteName = import.meta.env.VITE_SITE_NAME?.trim();
export const authSiteName: string | undefined = rawSiteName || undefined;

export const userServiceUrl = requireEnv(
  import.meta.env.VITE_USER_SERVICE_URL,
  "VITE_USER_SERVICE_URL",
);
export const userServiceApiKey = requireEnv(
  import.meta.env.VITE_USER_SERVICE_API_KEY,
  "VITE_USER_SERVICE_API_KEY",
);
